window.ColorUtils = {
    /**
     * convert hue to rgb
     * @param p {number}
     * @param q {number}
     * @param t {number}
     * @returns {number}
     */
    hueToRgb: (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1/6) return p + (q - p) * 6 * t;
        if (t < 1/2) return q;
        if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    },
    /**
     * convert hsl values to rgb values
     * @param h hue should be a range between 0 and 1
     * @param s saturation should be a range between 0 and 1
     * @param l lightness should be a range between 0 and 1
     * @returns {[number,number,number]} represents the [red, green, blue] values
     */
    convertHslToRgb: (h, s, l) => {
        let r, g, b;

        if (s === 0) {
            r = g = b = l; // achromatic
        } else {
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = ColorUtils.hueToRgb(p, q, h + 1/3);
            g = ColorUtils.hueToRgb(p, q, h);
            b = ColorUtils.hueToRgb(p, q, h - 1/3);
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    },
    /**
     * convert rgb values to hsl values
     * @param colorComponent the color component should be a range between 0 and 255
     * @returns {string} returns the hex representation of the color channel
     */
    colorComponentToHex: (colorComponent) => {
        const hex = colorComponent.toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    },
    /**
     * convert rgb values to hsl values
     * @param r red should be a range between 0 and 255
     * @param g green should be a range between 0 and 255
     * @param b blue should be a range between 0 and 255
     * @returns {string} returns the hex representation of the color
     */
    convertRGBToHex: (r, g, b) => {
        return `#${ColorUtils.colorComponentToHex(r)}${ColorUtils.colorComponentToHex(g)}${ColorUtils.colorComponentToHex(b)}`;
    },
    /**
     * generates random color using the provided ranges
     * @param hueRange the hue channel range the values should be a range between 0 and 1
     * @param satRange the saturation channel range the values should be a range between 0 and 1
     * @param lightRange the lightness channel range the values should be a range between 0 and 1
     * @returns {[number,number,number]} represents the [hue, saturation, lightness] values
     */
    generateRandomHslColor: (hueRange, satRange, lightRange) => {
        hueRange = hueRange || [0, 1];
        satRange = satRange || [0, 1];
        lightRange = lightRange || [0, 1];

        const hue = hueRange[0] === hueRange[1] ? hueRange[0] : (Math.random() * (hueRange[1] - hueRange[0]) + hueRange[0]);
        const sat = satRange[0] === satRange[1] ? satRange[0] : (Math.random() * (satRange[1] - satRange[0]) + satRange[0]);
        const light = lightRange[0] === lightRange[1] ? lightRange[0] : (Math.random() * (lightRange[1] - lightRange[0]) + lightRange[0]);

        return [hue, sat, light];
    },
    /**
     * generates a random color
     * @returns {string} the random color in hex format
     */
    getRandomColor: function () {
        const letters = '0123456789ABCDEF';
        let color = '#';

        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },
    normalizeHex: function (hex) {
        var hexDigits = hex.substring(1);
        return (hexDigits.length > 3) ? hexDigits : hexDigits.replaceAll(/(.{1})/g, '$1$1');
    }
};
